import _ from 'lodash';
import globalDomains from './global-domains';

//마켓정보
export const MARKET_STORE_INFO = {
  android: 'market://details?id=kr.co.nowcom.mobile.afreeca',
  ios: 'https://itunes.apple.com/kr/app/id334185830?mt=8',
};

// api 등에서 리턴되는 스네이크 케이스를 카멜 케이스로 변환
export const camelizeObject = (object) => {
  return _.transform(object, (acc, value, key, target) => {
    const camelKey = _.isArray(target) ? key : _.camelCase(key);

    acc[camelKey] = _.isObject(value) ? camelizeObject(value) : value;
  });
};

/**
 * 객체/배열의 모든 키를 스네이크 케이스로 변환 (재귀)
 * @param input 변환할 값(객체, 배열, 원시값)
 * @returns 변환된 값
 */
export const convertKeysToSnakeCase = (input) => {
  if (Array.isArray(input)) {
    return input.map(convertKeysToSnakeCase);
  } else if (_.isObject(input) && input !== null) {
    return _.transform(
      input,
      (acc, value, key) => {
        // key가 문자열일 때만 변환
        const snakeKey =
          typeof key === 'string'
            ? key.replace(/([a-z])([A-Z])/g, '$1_$2').toLowerCase()
            : key;
        acc[snakeKey] = convertKeysToSnakeCase(value);
      },
      {},
    );
  }
  return input;
};

export const parseCookie = (cookieValue) => {
  const pairs = cookieValue.split('&');
  const cookieObj = {};
  pairs.forEach((pair) => {
    const [key, value] = pair.split('=');
    cookieObj[key] = value;
  });
  return cookieObj;
};

/**
 * 현재 운영 체제가 macOS인지 Windows인지 확인하는 함수
 * @returns {string} - 운영 체제 이름
 */
export const getOS = () => {
  if (typeof window !== 'undefined' && typeof navigator !== 'undefined') {
    const userAgent = window.navigator.userAgent.toLowerCase();

    if (userAgent.includes('win')) {
      return 'win';
    } else if (userAgent.includes('mac')) {
      return 'mac';
    } else if (userAgent.includes('linux')) {
      return 'linux';
    } else {
      return 'unknown';
    }
  }
  return '';
};

// 운영체제 체크 확대
export const getFullOS = () => {
  if (typeof window !== 'undefined' && typeof navigator !== 'undefined') {
    const userAgent = navigator.userAgent.toLowerCase();

    if (userAgent.includes('windows nt')) {
      return 'windows';
    } else if (userAgent.includes('win')) {
      return 'win';
    } else if (userAgent.includes('mac')) {
      return 'mac';
    } else if (
      userAgent.includes('iphone') ||
      userAgent.includes('ipad') ||
      userAgent.includes('ipod')
    ) {
      return 'ios';
    } else if (userAgent.includes('android')) {
      return 'aos';
    } else if (userAgent.includes('linux')) {
      return 'linux';
    } else if (userAgent.includes('tizen')) {
      return 'tizen';
    } else if (userAgent.includes('freebsd')) {
      return 'freebsd';
    } else if (userAgent.includes('blackberry') || userAgent.includes('bb10')) {
      return 'blackberry';
    }

    return 'unknown';
  }
  return '';
};

/**
 * 현재 장치가 모바일인지 PC인지 확인
 * @returns {'mobile' | 'pc'} - 'mobile' 또는 'pc'
 */
export const getDeviceType = () => {
  if (typeof window !== 'undefined' && typeof navigator !== 'undefined') {
    const userAgent = window.navigator.userAgent.toLowerCase();
    if (/mobile|android|iphone|ipad|tablet/i.test(userAgent)) {
      return 'mobile';
    } else {
      return 'pc';
    }
  }
  return '';
};

/**
 * 웹뷰 접속 여부를 확인하는 유틸함수
 */
export const isWebview = () => {
  const uagent = navigator.userAgent.toLocaleLowerCase();
  return uagent.indexOf('afreeca webview') > -1 ||
    uagent.indexOf('afreeca up webview') > -1 ||
    uagent.indexOf('sooplive webview') > -1 ||
    uagent.indexOf('sooplive up webview') > -1
    ? true
    : false;
};

/**
 * 객체를 query string 형태로 변환
 * @param {Object} obj - 변환할 객체
 * @returns {string} - query string
 */
export const objectToQueryString = (obj) => {
  const params = new URLSearchParams(obj);
  return params.toString();
};

/**
 * 데이터를 배열 형태로 변환
 * @param {any} data - 변환할 데이터
 * @returns {Array} - 변환된 배열 데이터
 */
export const convertToArray = (data) => {
  // 데이터가 배열인지 확인
  if (Array.isArray(data)) {
    return data;
  }

  // 데이터가 객체인 경우, 값을 배열로 변환
  if (typeof data === 'object' && data !== null) {
    return Object.values(data);
  }

  // 데이터가 문자열인 경우, 문자열을 배열로 변환
  if (typeof data === 'string') {
    return [data];
  }

  // 데이터가 숫자인 경우, 숫자를 배열로 변환
  if (typeof data === 'number') {
    return [data];
  }

  // 데이터가 null 또는 undefined인 경우, 빈 배열 반환
  if (data === null || data === undefined) {
    return [];
  }

  // 그 외 다른 데이터 타입인 경우, 데이터 자체를 배열로 변환
  return [data];
};

export const decodeHtmlEntities = (str) => {
  if (!str) {
    return '';
  }

  return str
    .replace(/&lt;/g, '<')
    .replace(/&gt;/g, '>')
    .replace(/&quot;/g, '"')
    .replace(/&amp;/g, '&')
    .replace(/&#039;/g, "'");
};

export const preProcessValue = (str) => {
  // '%' 문자 처리: 올바르지 않은 % 인코딩을 안전하게 처리
  str = str.replace(/%(?![0-9A-Fa-f]{2})/g, '%25');

  // HTML 및 URL에서 특별한 의미를 갖는 문자들을 URL 인코딩
  const specialChars = {
    '<': '%3C',
    '>': '%3E',
    '"': '%22',
    "'": '%27',
    '`': '%60',
    '=': '%3D',
    '{': '%7B',
    '}': '%7D',
    '[': '%5B',
    ']': '%5D',
    '|': '%7C',
    '\\': '%5C',
    '^': '%5E',
    '~': '%7E',
  };

  str = str.replace(/[<>"'`={}[\]|\\^~]/g, (match) => specialChars[match]);

  // '&' 문자 처리: HTML 엔티티의 시작일 수 있으므로 조건부로 처리
  str = str.replace(/&(?![a-zA-Z0-9#]+;)/g, '%26');

  // '#' 문자 처리: URL 프래그먼트의 시작을 나타낼 수 있으므로 조건부로 처리
  str = str.replace(/#/g, '%23');

  // '+' 문자 처리: URL에서 공백을 나타낼 수 있으므로 인코딩
  str = str.replace(/\+/g, '%2B');

  return str;
};

/**
 * 모든 HTML 엔티티를 변환하는 함수 (DOM을 활용)
 */
export const decodeFullHtmlEntities = (str) => {
  if (!str) {
    return '';
  }

  const textarea = document.createElement('textarea');
  textarea.innerHTML = str;
  return textarea.value;
};

export const blockDuringMaintenance = () => {
  if (
    typeof navigator.userAgent === 'undefined' ||
    navigator.userAgent == null
  ) {
    //UA 가 없으면 기본 차단 실행
    location.href = 'https://www.afreecatv.com/not_found.htm';
  } else {
    if (
      navigator.userAgent
        .toLocaleLowerCase()
        .match(
          new RegExp('(Sooplive Webview|Sooplive API)[2]?/(8.0.0)', 'i'),
        ) === null
    ) {
      //앱 이외의 접근시, 차단 실행
      location.href = 'https://www.afreecatv.com/not_found.htm';
    }
  }
};

export const setPosterImageObserver = () => {
  try {
    const $container = document.querySelector('html');
    const handleDarkModeChange = () => {
      const newMode = document.documentElement.getAttribute('dark');
      // setIsDarkMode(newMode);

      // 오류로 인해 변경된 이미지를 다시 설정
      document.querySelectorAll('img[data-replaced="true"]').forEach((img) => {
        if (newMode) {
          img.src = `${globalDomains.RES_AFREECATV}/images/svg/category_thumb_default_dark.svg`;
        } else {
          img.src = `${globalDomains.RES_AFREECATV}/images/svg/category_thumb_default.svg`;
        }
      });
    };

    const observer = new MutationObserver(handleDarkModeChange);
    observer.observe($container, {
      attributes: true,
      attributeFilter: ['dark'],
    });

    return () => {
      observer.disconnect();
    };
  } catch (error) {}
};

/**
 * 객체 프로퍼티의 모든 값을 대문자로 반환
 * @param {Object} obj
 * @returns {Object}
 */
export const uppercaseObjectValue = (obj) => {
  return Object.keys(obj).reduce((acc, key) => {
    acc[key] = obj[key].toUpperCase();
    return acc;
  }, {});
};

export const isValueNaN = (obj) => {
  return isNaN(obj) ? 0 : obj;
};

export const ensureHttpsUrl = (url) => {
  if (!url) {
    return '';
  }
  return url.replace(/^(?:https?:)?\/\//i, 'https://');
};

/**
 * 이벤트 & 드롭스 태그 클릭 시 로그 발송에 필요한 location 정보를 현재 URL 경로 기반으로 판단하는 유틸 함수
 * @desc utils/main/search에 비슷한 로직(getUrlLocation)이 있으나 태그 로그의 요구사항과 1:1로 매칭되지 않아서 별도 구현
 * @todo 태그 location간 통일에 대한 협의
 */
export const getLocationForTagClickLog = (path, search) => {
  if (!path) {
    return '';
  }

  path = path.split('/');
  const [, rootPath] = path;

  if (rootPath === 'search' && search.includes('tagname')) {
    return 'tag_search';
  } else if (rootPath === 'search') {
    return 'total_search';
  } else if (rootPath === 'live') {
    return 'live_main';
  } else if (rootPath === 'directory' && path.length <= 3) {
    return 'directory';
  } else if (rootPath === 'directory') {
    return 'directory_cate';
  } else if (rootPath === 'my') {
    return 'my';
  } else if (rootPath === 'starrank') {
    return 'ranking';
  } else if (rootPath === 'help') {
    return 'help';
  } else if (rootPath === '' || rootPath === undefined) {
    // www.sooplive.co.kr/ 혹은 www.sooplive.co.kr 모두 포함
    return 'main';
  } else {
    // 미정의된 영역
    return rootPath;
  }
};

// 특수문자 제거 로직, 공백과 문자만 남기고 특수문자 들은 전부 제거
export const removeSpecialCharacters = (originalText) => {
  return originalText?.replace(/[^\p{L}0-9]/gu, '');
};

//객체내에서 벨류가 없는 키값 제거
export const filterEmptyParams = (obj) =>
  Object.fromEntries(
    Object.entries(obj).filter(
      ([, value]) => value !== '' && value !== undefined && value !== null,
    ),
  );

export const formatPrice = (price) => {
  const numericPrice = Number(price);
  if (isNaN(numericPrice)) {
    console.log('Invalid price:', price);
    return price; // 혹시 숫자로 변환할 수 없는 경우 원래 값을 반환
  }
  return numericPrice.toLocaleString('ko-KR');
};

/**
 * 할인율을 계산하는 유틸 함수
 *
 * @param originalPrice 원래 가격
 * @param discountPrice 할인된 가격
 * @returns 할인율 (정수 %)
 */
export const getDiscountRate = (originalPrice = 0, discountPrice = 0) => {
  if (originalPrice === 0) {
    return 0;
  }
  return Math.round((discountPrice / originalPrice) * 100);
};

//프로필 이미지 변형 함수
export const getWebpProfileSrc = (
  userId,
  extention = 'webp',
  size = 'small',
) => {
  if (userId) {
    return `${globalDomains.STIMG_AFREECATV}/LOGO/${userId.substring(0, 2)}/${userId}${extention === 'webp' && size === 'small' ? '/m' : ''}/${userId}.${extention}`;
  }
};

export const isNull = (v) => v === null;
export const isEmpty = (v) => v === null || v === undefined || v === '';
